import type {
  MentionEntity,
  MessageSegment,
} from '@terra/shared-dto-chat-types';
import { Text } from '../../../components/styled/text';
import { useMentions } from '../mentions/ChatMentionsProvider';
import {
  REF_PATTERN,
  stripRichCardMetadataFromMessageText,
} from '../utils/userMessageDisplayText';
import { MentionContextPill } from '../context-pill/MentionContextPill';
import { CHAT_BODY_FONT_SIZE_PX } from './chat-nesting-layout';

export { REF_PATTERN };

type InlineMessageContentProps = {
  segments: MessageSegment[];
  mentionEntitiesById?: ReadonlyMap<string, MentionEntity>;
};

export function InlineMessageContent({
  segments,
  mentionEntitiesById,
}: InlineMessageContentProps) {
  const { onMentionClick } = useMentions();

  return (
    <Text
      fontSize={`${CHAT_BODY_FONT_SIZE_PX}px`}
      lineHeight={1.5}
      color="fg.muted"
      m={0}
      whiteSpace="pre-wrap"
      wordBreak="break-word"
      fontFamily="inherit"
    >
      {segments.map((segment, index) => {
        if (segment.type === 'mention') {
          const mentionEntity = mentionEntitiesById?.get(segment.entityId);

          return (
            <MentionContextPill
              key={index}
              entityId={segment.entityId}
              entityType={segment.entityType}
              label={segment.label}
              extraData={mentionEntity?.extraData}
              onClick={onMentionClick}
            />
          );
        }

        const cleanValue = stripRichCardMetadataFromMessageText(
          segment.value.replace(REF_PATTERN, ''),
        );

        if (!cleanValue) return null;

        return <span key={index}>{cleanValue}</span>;
      })}
    </Text>
  );
}
